"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScanCodeInitRequest = void 0;
var ScanCodeInitRequest = /** @class */ (function () {
    function ScanCodeInitRequest() {
    }
    return ScanCodeInitRequest;
}());
exports.ScanCodeInitRequest = ScanCodeInitRequest;
;
//# sourceMappingURL=scanCodeInit.request.js.map